import Base from './base';
import toasted from './toasted';
import { getter, commit } from './store';
import auth from './oauth';

function addAuthorization(options) {
  const token = getter('oauth/access_token');

  if (token) {
    const opts = options || {};
    if (!opts.headers) {
      opts.headers = {};
    }
    opts.headers['Authorization'] = 'Bearer ' + token;
    return opts;
  }

  return options;
}

function _call(promiseBuilder, options) {
  return new Promise((resolve, reject) => {
    const opts = addAuthorization(options);
    commit('loader/work', 1);
    promiseBuilder(opts)
      .finally(() => {
        commit('loader/work', -1);
      })
      .then(resolve)
      .catch(response => {
        if (response.status > 0) {
          toasted.error('api.error.' + response.status, {
            text: response.status,
            icon: 'storage',
          });
          reject(response.body);
        }
      });
  });
}

function innerGet(api) {
  const http = api.vue().$http;
  const uri = api.uri;
  return options => http.get(uri, options);
}

function innerPost(api, body) {
  const http = api.vue().$http;
  const uri = api.uri;
  return options => http.post(uri, body, options);
}

function innerDelete(api, body) {
  const http = api.vue().$http;
  const uri = api.uri;

  return options => {
    if (body) {
      options = options || {};
      options.body = body;
    }
    return http.delete(uri, options);
  };
}

function innerPut(api, body) {
  const http = api.vue().$http;
  const uri = api.uri;
  return options => http.put(uri, body, options);
}

function call(promiseBuilder, options) {
  return auth.renewAccessToken(() => _call(promiseBuilder, options));
}

export default class Api extends Base {
  constructor(uri, base) {
    super();
    this.uri = (base || '/api/') + uri;
  }

  get(options) {
    return call(innerGet(this), options);
  }

  post(body, options) {
    return call(innerPost(this, body), options);
  }

  put(body, options) {
    return call(innerPut(this, body), options);
  }

  delete(body, options) {
    return call(innerDelete(this, body), options);
  }
}
